import React, {Component} from 'react';

import './styles.scss';

export default class EmptyState extends Component {

    render() {
        return (
            <div className={"empty-note"}>
                <div className={"text"}>{this.props.text}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/emptyState/EmptyState.js